module.exports = __webpack_public_path__ + "static/img/A55_bg.7c7c272.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/A55_bg.jpg
// module id = SmD8
// module chunks = 0